import React, { useState } from "react";
import Navbar from "./navbar/Navbar";
import "../scss/News.css";
import NewsList from "./News/NewsList";
import NewsSettings from "./News/Settings";

const NewsPage = () => {
  // User Data
  const data = {
    userData: {
      username: "Prashant",
      profilePic: "https://avatars.githubusercontent.com/u/43730425?v=4",
      totalNotification: 101,
    },
  };
  const handleLoadMore = () => {
    setPageSize((prevPageSize) => prevPageSize + 6);
  };

  let [topicName, setTopicName] = useState("Programming");
  const [articlesData, setArticlesData] = useState([]);
  const [pageSize, setPageSize] = useState(6);
  const [searchInput] = useState("");

  const pageName = "News - " + topicName;

  const handleTopicChange = (event) => {
    if (searchInput === "") {
      setTopicName(event.target.value);
    } else {
      setTopicName(searchInput);
    }
  };

  const handleArticlesData = (data) => {
    setArticlesData(data);
  };
  

  return (
    <div className="news-section">
      <Navbar data={data} pageName={pageName}  handleTopicChange={handleTopicChange}  />

      <div className="news-inner">
        <NewsList topicName={topicName} pageSize={pageSize} sendData={handleArticlesData} />
        <NewsSettings
          topicName={topicName}
          handleTopicChange={handleTopicChange}
          searchInput={searchInput}
          pageSize={pageSize}
          handlePageSizeChange={(event) => setPageSize(parseInt(event.target.value))}
          articlesData={articlesData}
          
          handleLoadMore={handleLoadMore}
        />
      </div>
    </div>
  );
};

export default NewsPage;
